import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const au3Api = createApi({
    reducerPath: "boundary/au3",
    baseQuery: axiosBaseQuery,
    tagTypes: ["au3List"],
    endpoints: (builder) =>({
        au3FindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['au3List'],
            query: (query = '') => ({
                url: "boundary/au3/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        au3Create: builder.mutation({
            invalidatesTags: ['au3List'],
            query: (data)=>({url: "boundary/au3/", method: "POST", data})
        }),
        au3Update: builder.mutation({
            invalidatesTags: ['au3List'],
            query: (data)=>({url: "/boundary/au3/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        au3Delete: builder.mutation({
            invalidatesTags: ['au3List'],
            query: (id)=>({url: "/boundary/au3/"+id, method: "DELETE"})
        }),
    })
})

export const { useAu3FindAllQuery, useAu3CreateMutation, useAu3UpdateMutation, useAu3DeleteMutation } = au3Api;
export {au3Api};
